import script from "./AsideModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AsideModal.vue?vue&type=script&setup=true&lang=ts"

import "./AsideModal.vue?vue&type=style&index=0&id=323f4b2e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-323f4b2e"]])

export default __exports__